<template>
  <TransactionListTemplate
    :screenConfig="setScreenConfig"
    :rowClick="rowClickCallBack"
    :persistenceKey="'supplier-invoiced-list'"
    :gcPopupConfig="gcPopupConfig"
    :setLoading="setLoading"
    ref="supplier-invoiced-list"
  />
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";

import TransactionListTemplate from "@/templates/transaction-list";
import { FeatureStorage } from "@/_services/storage";
import { SupplierInvoiceService } from "@/_services/api/purchasing/supplier-invoice.service";
import ColumnWidth from "@/_helpers/data-grid/ColumnWidth";
import { IsResponseDataValid } from "../../_helpers/ui/helpers";

export default {
  props: {},
  mixins: [RouteMixin, FormMixin],
  components: {
    TransactionListTemplate,
  },
  data() {
    return {
      gcPopupVisible: false,
      newDueDateModel: {
        Code: undefined,
        SupplierName: undefined,
        InvoiceNo: undefined,
        InvoiceDate: undefined,
        DueDate: undefined,
        NewDueDate: undefined,
        NewInvoiceDate: undefined,
      },
      NewDueDate: {
        Min: undefined,
        Max: undefined,
      },
      setLoading: false,
      AccountingPeriod: {
        StartDate: undefined,
        EndDate: undefined,
      },
      SelectAllDueDate: false,
    };
  },
  computed: {
    gcPopupConfig() {
      return {
        title: "Adjust Due Date",
        dataModel: this.newDueDateModel,
        callBack: this.gcPopupCallBack,
        gcPopupVisible: this.gcPopupVisible,
        height: this.SelectAllDueDate ? 50 : 400,
        formContentReady: this.formContentReady,
        formOptions: {
          gcLabelLocation: "left",
        },
        items: [
          {
            itemType: "group",
            caption: "",
            colCount: 1,
            items: [
              {
                screenField: "Invoice",
                dataField: "Code",
                label: {
                  text: "Supplier Invoice #",
                },
                visible: !this.SelectAllDueDate,
              },
              {
                dataField: "SupplierName",
                label: {
                  text: "Supplier Name",
                },
                visible: !this.SelectAllDueDate,
              },
              {
                itemType: "group",
                caption: "",
                colCount: 2,
                visible: !this.SelectAllDueDate,
                items: [
                  {
                    dataField: "TermCalculation",
                    label: { text: "Term Method" },
                    id: "term-calculation-selectBox",
                  },
                  {
                    dataField: "Terms",
                    label: { text: "Terms Days" },
                  },
                ],
              },
              {
                screenField: "Invoice",
                dataField: "InvoiceNo",
                label: {
                  text: "Invoice Number",
                },
                visible: !this.SelectAllDueDate,
              },
              {
                screenField: "DateIn",
                dataField: "InvoiceDate",
                label: {
                  text: "Current Invoice Date",
                },
                visible: !this.SelectAllDueDate,
              },
              {
                screenField: "DueDate",
                label: {
                  text: "Current Due Date",
                },
                visible: !this.SelectAllDueDate,
              },

              {
                screenField: "DateIn",
                dataField: "NewInvoiceDate",
                label: {
                  text: "New Invoice Date",
                },
                required: true,
                editorOptions: {
                  allowUpdate: true,
                  onValueChanged: (e) => {
                    this.updateDueDateFromModel(e);
                  },
                  onFocusIn: (e) => {
                    if (e.event.target.select) e.event.target.select();
                  },
                },
                visible: !this.SelectAllDueDate,
              },
              {
                screenField: "DueDate",
                dataField: "NewDueDate",
                label: {
                  text: "New Due Date",
                },
                required: true,
                editorOptions: {
                  min: this.NewDueDate.Min,
                  // max: this.NewDueDate.Max,
                  allowUpdate: true,
                  onValueChanged: (e) => {
                    if (e.event) {
                      if (
                        e.value != null &&
                        new Date(e.value) < new Date(this.NewDueDate.Min)
                      ) {
                        e.component.beginUpdate();
                        e.component.option("value", e.previousValue);
                        e.component.endUpdate();
                      } else this.onChangeNewDueDate(e);
                    }
                  },
                },
              },
            ],
          },
        ],
        save: {
          text: "Update",
          clickCallback: (e) => {
            this.onGcPopUpUpdate(e);
          },
          // disabled: !this.newDueDateModel.NewDueDate,
          disabled: this.SelectAllDueDate
            ? this.newDueDateModel.NewDueDate === undefined
            : this.newDueDateModel.NewDueDate === this.newDueDateModel.DueDate,
        },
        back: {
          text: "Cancel",
          clickCallback: () => {
            this.gcPopupCallBack();
          },
        },
      };
    },
    setScreenConfig() {
      return {
        title: "Purchase Orders",
        ScreenName: "Purchase Orders - Invoiced",
        selectedIndex: 3,
        tabs: [
          {
            text: "All",
            path: `/purchase-order`,
            applicationFeatureCode: "PurchaseOrder",
          },
          {
            text: "To Receive",
            path: `/goods-in`,
            applicationFeatureCode: "GoodsIn",
          },
          {
            text: "Received",
            path: `/goods-in-review`,
            applicationFeatureCode: "GoodsIn",
          },
          {
            text: "Invoiced",
            path: `/supplier-invoiced`,
            applicationFeatureCode: "SupplierInvoice",
          },
        ],

        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "SupplierInvoiceList",
              filter: "",
              serverPaging: true,
              allowGrouping: false,
            },
            options: {
              selectionMode: "multiple",
            },
          },

          toolbar: {
            search: false,
            columnChooser: true,
            export: false,
            openFilter: true,
            expand: false,
            customButtons: [
              {
                icon: "plus",
                label: "Add Invoice",
                route: "/supplier-invoice/create",
                routeQuery: {
                  from: "supplier-invoiced",
                },
                clickAction: {},
                buttonLocation: "left",
              },
              {
                icon: "more",
                widget: "dxDropDownButton",
                label: "",
                clickAction: {},
                buttonLocation: "right",
                options: {
                  icon: "more",
                  showArrowIcon: false,
                  keyExpr: "menuText",
                  displayExpr: "menuText",
                  dropDownOptions: { width: 150 },
                  items: [
                    {
                      menuText: "Adjust Due Date",
                    },
                  ],
                  onItemClick: () => {
                    this.changeAllDueDateVisible();
                  },
                },
              },
            ],
          },
          columns: [
            {
              screenField: "Invoice",
              dataField: "Invoice",
              sortOrder: "desc",
              sortIndex: 0,
              allowHiding: false,
              fixed: true,
              fixedPosition: "left",
              type: "Integer",
              filterIndex: 0,
              filterDataField: "Invoice",
              filterLabel: "Invoice #",
              width: ColumnWidth.InvoiceNumber.width,
            },
            {
              screenField: "PurchaseOrderNo",
              filterDataField: "PurchaseOrderNoList",
              showInColumnChooser: false,
              visible: false,
              filterIndex: 1,
              filterLabel: "Purchase Order",
              type: "Integer",
              filterDataRelationship: "Comma",
            },
            {
              screenField: "Code",
              filterDataField: "GoodsInNoList",
              showInColumnChooser: false,
              visible: false,
              filterIndex: 1,
              filterLabel: "Goods in",
              type: "Integer",
              filterDataRelationship: "Comma",
            },
            {
              screenField: "Supplier",
              gridDataField: "SupplierName",
              cellTemplateRecord: {
                primary: [
                  {
                    dataField: "SupplierName",
                  },
                ],
                secondary: [
                  {
                    dataField: "SupplierCode",
                  },
                ],
              },
              exportFields: [
                {
                  dataField: "SupplierCode",
                  label: "Supplier Code",
                },
                {
                  dataField: "SupplierName",
                  label: "Supplier Name",
                },
              ],
              filterIndex: 1,
              filterDataField: "SupplierCode",
            },
            {
              screenField: "ConNote",
              label: "Supplier Reference",
              dataField: "SupplierInvoiceNo",
              filterLabel: "Supplier Reference",
              filterDataField: "SupplierInvoiceNo",
              dataType: "string",
              type: "Text",
              filterIndex: 2,
              minWidth: ColumnWidth.PaymentReference.minWidth,
            },
            {
              screenField: "DateIn",
              filterIndex: 3,
            },
            {
              screenField: "DueDate",
              filterIndex: 4,
            },
            {
              screenField: "Currency",
              gridDataField: "FXCurrency",
              cellTemplate: false,
              width: ColumnWidth.CurrencyCode.width,
              minWidth: ColumnWidth.CurrencyCode.minWidth,
            },
            {
              screenField: "FXTotal",
              label: "Total (AUD)",
              dataField: "Total",
              width: ColumnWidth.TotalAmount.width,
              minWidth: ColumnWidth.TotalAmount.minWidth,
            },
            {
              screenField: "FXTotal",
              label: "Total (FX)",
              dataField: "FXTotal",
              width: ColumnWidth.TotalAmount.width,
              minWidth: ColumnWidth.TotalAmount.minWidth,
            },
            {
              screenField: "Balance",
              label: "Balance (AUD)",
              width: ColumnWidth.TotalAmount.width,
              minWidth: ColumnWidth.TotalAmount.minWidth,
            },
            {
              screenField: "Balance",
              label: "Balance (FX)",
              dataField: "FXBalance",
              width: ColumnWidth.TotalAmount.width,
              minWidth: ColumnWidth.TotalAmount.minWidth,
            },
            {
              screenField: "OrderStatus",
              dataField: "Status",
              filterDataField: "Status",
              // filterIndex: 5,
              dataSourceConfig: {
                data: ["Open", "Paid", "Overdue"],
              },
            },
            {
              screenField: "GridRecordEmail",
              cssClass: "padding-7",
              ReferenceNoField: "Invoice",
            },
            {
              screenField: "GridRecordPDFView",
              cssClass: "padding-7",
            },
            {
              screenField: "GridRecordPrint",
              cssClass: "padding-7",
              ReferenceNoField: "Invoice",
            },
            {
              screenField: "GridRecordEllipsisMenu",
              cssClass: "padding-7",
              allowSearch: false,
              ellipsisMenu: {
                itemAction: (data) => {
                  return [
                    {
                      menuText: "Adjust Due Date",
                      data: data,
                      disabled:
                        data.data.Status === "Paid" ||
                        !FeatureStorage.checkPermission(
                          "SupplierInvoice",
                          "create",
                        ),
                      clickAction: this.visibleGcPopUp,
                    },
                    {
                      menuText: "Pay",
                      data: data,
                      clickAction: this.goToPay,
                      disabled:
                        data.data.Status === "Paid" ||
                        !FeatureStorage.checkPermission(
                          "CashPayment",
                          "create",
                        ),
                    },
                    {
                      menuText: "Credit",
                      data: data,
                      clickAction: this.goToSupplierCredit,
                      disabled:
                        !(data.data.PurchaseOrderLinked === "Y") ||
                        data.data.Status === "Paid" ||
                        data.data.Status === "Credit" ||
                        data.data.Status === "Credited" ||
                        !FeatureStorage.checkPermission(
                          "SupplierInvoice",
                          "create",
                        ),
                    },
                  ];
                },
                keyExpr: "menuText",
                displayExpr: "menuText",
              },
            },
          ],
        },
      };
    },
  },
  methods: {
    formContentReady(e) {
      const formInstance = e.component;
      if (formInstance) {
        this.$nextTick(() => {
          setTimeout(() => {
            if (formInstance.getEditor("NewInvoiceDate"))
              formInstance.getEditor("NewInvoiceDate").instance().focus();
          }, 400);
        });
      }
    },
    async goToSupplierCredit(e) {
      await this.$router.push({
        path: `supplier-credit/create/${e.Invoice}`,
        query: {
          from: "/supplier-invoiced",
          SUP_ID: encodeURI(JSON.stringify(e.SupplierCode)),
        },
      });
    },
    async changeAllDueDateVisible() {
      this.newDueDateModel.NewDueDate = undefined;
      this.NewDueDate = {
        Min: undefined,
        Max: undefined,
      };
      await SupplierInvoiceService.getActiveAccountingPeriodStartDate().then(
        (res) => {
          this.NewDueDate.Min = new Date(
            res.data.value[0].StartDate.replace("Z", ""),
          );
        },
      );
      this.SelectAllDueDate = true;
      this.gcPopupVisible = true;
    },
    gcPopupCallBack() {
      this.SelectAllDueDate = false;
      this.gcPopupVisible = false;
    },
    async onGcPopUpUpdate(e) {
      let payload = {
        Code: e.Code,
        DueDate: new Date(e.NewDueDate).toSaveDate(),
      };
      this.setLoading = true;
      if (this.SelectAllDueDate) {
        let selectedRows =
          this.$refs["supplier-invoiced-list"].$refs[
            "transactionListGrid"
          ].selectedRowData();

        if (selectedRows.length === 0) {
          this.$alert(
            "Please select one or more invoices to update due date.",
            "Warning",
            {
              confirmButtonText: "OK",
            },
          );
          this.setLoading = false;
          return;
        }
        payload.Invoices = selectedRows.map((x) => x.Invoice);
        this.gcPopupCallBack();
        await SupplierInvoiceService.saveSupplierInvoiceDueDateBulkUpdate(
          payload,
        )
          .then((res) => {
            if (res) this.setLoading = false;
            let dataGrid =
              this.$refs["supplier-invoiced-list"].$refs[
                "transactionListGrid"
              ].getGridInstance();
            if (dataGrid) {
              dataGrid.deselectAll();
            }

            this.$notify(
              `Supplier Invoice Due Dates Successfully Updated`,
              "success",
            );

            this.$refs["supplier-invoiced-list"].$refs[
              "transactionListGrid"
            ].gridRepaint();
          })
          .catch((err) => {
            this.setLoading = false;
            this.serverError = {
              err: err,
              msg: "Update Failed.",
              time: new Date().getTime(),
            };
          });
      } else {
        this.gcPopupCallBack();
        payload.InvoiceDate = new Date(e.NewInvoiceDate).toSaveDate();
        await SupplierInvoiceService.saveSupplierInvoiceDueDate(payload)
          .then((res) => {
            if (res) this.setLoading = false;

            this.$notify(
              `Supplier Invoice #${res.data.Code} Due Date Successfully Updated`,
              "success",
            );

            this.$refs["supplier-invoiced-list"].$refs[
              "transactionListGrid"
            ].gridRepaint();
          })
          .catch((err) => {
            this.setLoading = false;
            this.serverError = {
              err: err,
              msg: "Update Failed.",
              time: new Date().getTime(),
            };
          });
      }
    },
    onChangeNewDueDate(e) {
      this.newDueDate = e;
    },

    updateDueDateFromModel(e) {
      if (!this.newDueDateModel || !e.event) return;
      else {
        this.InvoiceDate = e.value;
        var year = new Date(e.value).getFullYear();
        var month = new Date(e.value).getMonth();
        if (this.newDueDateModel.TermCalculation == "ACTUAL") {
          this.newDueDateModel.NewDueDate = new Date(e.value).addDays(
            this.newDueDateModel.Terms,
          );
        } else if (
          this.newDueDateModel.TermCalculation == "EOM" &&
          this.newDueDateModel.Terms % 30 == 0
        ) {
          this.newDueDateModel.NewDueDate = new Date(
            year,
            month + this.newDueDateModel.Terms / 30 + 1,
            0,
          );
        } else if (this.newDueDateModel.TermCalculation == "SPLIT") {
          let calculatedDate = new Date(this.newDueDateModel.NewInvoiceDate);
          if (calculatedDate.getDate() <= 15) {
            this.newDueDateModel.NewDueDate = new Date(
              calculatedDate.getFullYear(),
              calculatedDate.getMonth() + 1,
              0,
            );
          } else {
            this.newDueDateModel.NewDueDate = new Date(
              calculatedDate.getFullYear(),
              calculatedDate.getMonth() + 1,
              15,
            );
          }
        } else {
          this.newDueDateModel.NewDueDate = new Date(
            year,
            month + 1,
            0,
          ).addDays(this.newDueDateModel.Terms);
        }

        this.newDueDate = true;
      }
    },
    async visibleGcPopUp(data) {
      this.setLoading = true;

      const invoiceRes = await SupplierInvoiceService.getByCode(data.Invoice, {
        select: "Code, InvoiceDate, TermCalculation, Terms",
      });

      this.newDueDateModel = {
        Code: data.Invoice,
        SupplierName: data.SupplierName,
        InvoiceNo: data.SupplierInvoiceNo,
        InvoiceDate: data.DateIn,
        DueDate: data.DueDate,
        NewDueDate: data.DueDate,
      };

      if (IsResponseDataValid(invoiceRes)) {
        const invoiceData = invoiceRes.data.value[0];
        this.newDueDateModel.TermCalculation = invoiceData.TermCalculation;
        this.newDueDateModel.Terms = invoiceData.Terms;
        this.newDueDateModel.InvoiceDate = invoiceData.InvoiceDate;
        this.newDueDateModel.NewInvoiceDate = invoiceData.InvoiceDate;
      }

      let currentInvoiceDate = data.DateIn;
      if (this.AccountingPeriod.StartDate) {
        let accountingPeriod = new Date(
          this.AccountingPeriod.StartDate.data.value[0].StartDate.replace(
            "Z",
            "",
          ),
        );

        if (currentInvoiceDate.getTime() > accountingPeriod.getTime()) {
          this.NewDueDate.Min = currentInvoiceDate;
        } else {
          this.NewDueDate.Min = accountingPeriod;
        }
      } else {
        this.NewDueDate.Min = currentInvoiceDate;
      }

      if (this.AccountingPeriod.EndDate) {
        let accountingPeriod =
          this.AccountingPeriod.EndDate.data.value[0].EndDate;
        this.NewDueDate.Max = new Date(accountingPeriod.replace("Z", ""));
      }
      this.setLoading = false;
      this.gcPopupVisible = true;
    },
    goToPay(e) {
      this.$router.push({
        path: `supplier-payment/create/${e.Invoice}`,
        query: {
          from: "/supplier-invoiced",
          SUP_ID: encodeURI(JSON.stringify(e.SupplierCode)),
        },
      });
    },

    rowClickCallBack(e) {
      if (
        e.rowType === "data" &&
        e.column.screenField !== "OrderStatus" &&
        e.column.screenField !== "GridRecordEmail" &&
        e.column.screenField !== "GridRecordPDFView" &&
        e.column.screenField !== "GridRecordPrint" &&
        e.column.screenField !== "GridRecordEllipsisMenu" &&
        e.column.type !== "selection"
      ) {
        this.onRowClicked(e, {
          view: this,
          page: "supplier-invoice",
          mode: "review",
          idProperty: "Invoice",
        });
      }
    },
  },

  async created() {
    this.AccountingPeriod.StartDate =
      await SupplierInvoiceService.getActiveAccountingPeriodStartDate();
    this.AccountingPeriod.EndDate =
      await SupplierInvoiceService.getActiveAccountingPeriodEndDate();
  },
};
</script>

<style lang="scss"></style>
